/**
 * Ghana Card Verification Status Constants
 * Task 2.4: Implement Ghana Card Verification Frontend
 * 
 * User Story: "As a claimant, I must upload my Ghana Card and see real-time verification progress 
 * before submitting a claim, with clear feedback if verification fails."
 * 
 * These constants define the possible states for Ghana Card verification during claim submission.
 */

export const PENDING_VERIFICATION = 'PENDING_VERIFICATION';
export const VERIFIED = 'VERIFIED';
export const VERIFICATION_FAILED = 'VERIFICATION_FAILED';

// Additional helper constants for UI display
export const VERIFICATION_STATUS_LABELS = {
  [PENDING_VERIFICATION]: 'Verification in Progress',
  [VERIFIED]: 'Ghana Card Verified',
  [VERIFICATION_FAILED]: 'Verification Failed'
};

export const VERIFICATION_STATUS_COLORS = {
  [PENDING_VERIFICATION]: 'text-yellow-600',
  [VERIFIED]: 'text-green-600', 
  [VERIFICATION_FAILED]: 'text-red-600'
};

export const VERIFICATION_BACKGROUND_COLORS = {
  [PENDING_VERIFICATION]: 'bg-yellow-50 border-yellow-200',
  [VERIFIED]: 'bg-green-50 border-green-200',
  [VERIFICATION_FAILED]: 'bg-red-50 border-red-200'
};
